<div class="page-wrapper">
  <div class="deco-blob-1"></div>
  <div class="deco-blob-2"></div>
  <div class="grid-overlay"></div>

  <div class="page-container">
    <!-- Header -->
    <header class="top-nav">
      <div class="hero-logo">
        <img src="../../assets/images/Logo.svg" alt="Nishwik Logo" class="img-fluid" />
      </div>
      <div class="nav-right">
        Already registered?
        <a routerLink="/login" class="link-btn">
          Sign In <i class="fas fa-arrow-right"></i>
        </a>
      </div>
    </header>

    <main class="main-content">
      <!-- Left Info Panel -->
      <section class="info-panel">
        <div class="badge-pill">
          <span class="badge-dot"></span>
          Next-Gen School Management
        </div>

        <h1 class="display-title">
          Join the Future<br />of <span class="gradient-text">Digital Education.</span>
        </h1>

        <p class="panel-desc">
          Empower students, teachers, and parents with a unified school
          management platform — from admissions to results, all in one place.
        </p>

        <div class="features-list">
          <div class="feature-item">
            <div class="f-icon">
              <i class="fas fa-user-graduate"></i>
            </div>
            <div class="f-content">
              <div class="f-title">Student Lifecycle Management</div>
              <div class="f-desc">Track admissions, attendance, and academic progress</div>
            </div>
          </div>
          <div class="feature-item">
            <div class="f-icon">
              <i class="fas fa-chalkboard-teacher"></i>
            </div>
            <div class="f-content">
              <div class="f-title">Teacher & Class Scheduling</div>
              <div class="f-desc">Smart timetables, leave management, and workload tracking</div>
            </div>
          </div>
          <div class="feature-item">
            <div class="f-icon">
              <i class="fas fa-chart-line"></i>
            </div>
            <div class="f-content">
              <div class="f-title">Exam Results & Analytics</div>
              <div class="f-desc">Automated marksheets, rank charts, and parent reports</div>
            </div>
          </div>
        </div>

        <!-- <div class="trust-strip">
          <div class="trust-stat">
            <span class="stat-num">1,200+</span>
            <span class="stat-label">Schools</span>
          </div>
          <div class="trust-divider"></div>
          <div class="trust-stat">
            <span class="stat-num">5M+</span>
            <span class="stat-label">Students</span>
          </div>
          <div class="trust-divider"></div>
          <div class="trust-stat">
            <span class="stat-num">28</span>
            <span class="stat-label">States</span>
          </div>
        </div> -->
      </section>

      <!-- Right Form Panel -->
      <section class="form-panel">
        <div class="signup-card">
          <div class="card-top-bar"></div>

          <div class="card-inner">
            <div class="card-header">
              <div class="card-eyebrow">School OS · Registration</div>
              <h2>Create Your Account</h2>
              <p>Fill in your details to get started</p>
            </div>

            <!-- Role Selector -->
            <!-- <div class="role-selector">
              <div *ngFor="let r of roles"
                   class="role-card"
                   [class.active]="selectedRole === r.id"
                   (click)="selectRole(r.id)">
                <div class="role-icon-wrap">
                  <i [class]="r.icon"></i>
                </div>
                <div class="role-info">
                  <span class="role-label">{{ r.label }}</span>
                  <span class="role-desc">{{ r.description }}</span>
                </div>
                <div class="role-check"><i class="fas fa-check"></i></div>
              </div>
            </div> -->

            <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">

              <!-- Personal Information -->
              <div class="form-section">
                <div class="section-header">
                  <div class="section-num">01</div>
                  <h3 class="section-label">Personal Information</h3>
                </div>

                <div class="form-row">
                  <div class="input-group">
                    <label>First Name <span class="req">*</span></label>
                    <div class="input-wrap">
                      <i class="fas fa-user input-icon"></i>
                      <input type="text" formControlName="firstName" placeholder="Rahul" />
                    </div>
                    <small class="field-error" *ngIf="signupForm.get('firstName')?.touched && signupForm.get('firstName')?.hasError('required')">
                      First name is required.
                    </small>
                  </div>
                  <div class="input-group">
                    <label>Last Name <span class="req">*</span></label>
                    <div class="input-wrap">
                      <i class="fas fa-user input-icon"></i>
                      <input type="text" formControlName="lastName" placeholder="Sharma" />
                    </div>
                    <small class="field-error" *ngIf="signupForm.get('lastName')?.touched && signupForm.get('lastName')?.hasError('required')">
                      Last name is required.
                    </small>
                  </div>
                </div>

                <div class="form-row">
                  <div class="input-group">
                    <label>Email Address <span class="req">*</span></label>
                    <div class="input-wrap">
                      <i class="fas fa-envelope input-icon"></i>
                      <input type="email" formControlName="email" placeholder="rahul@school.com" />
                    </div>
                    <small class="field-error" *ngIf="signupForm.get('email')?.touched && signupForm.get('email')?.hasError('required')">Email is required.</small>
                    <small class="field-error" *ngIf="signupForm.get('email')?.touched && signupForm.get('email')?.hasError('email')">Enter a valid email address.</small>
                  </div>
                  <div class="input-group">
                    <label>Mobile Number <span class="req">*</span></label>
                    <div class="input-wrap mobile-wrap">
                      <i class="fas fa-mobile-alt input-icon"></i>
                      <input type="tel" formControlName="mobileNumber" placeholder="9876543210" />
                      <!-- <button type="button" class="btn-otp" (click)="sendOtp()" [disabled]="otpSent && otpTimer > 0">
                        <span *ngIf="!otpSent"><i class="fas fa-paper-plane"></i> Verify</span>
                        <span *ngIf="otpSent && otpTimer > 0"><i class="fas fa-clock"></i> {{ otpTimer }}s</span>
                        <span *ngIf="otpSent && otpTimer === 0"><i class="fas fa-redo"></i> Resend</span>
                      </button> -->
                    </div>
                    <small class="field-error" *ngIf="signupForm.get('mobileNumber')?.touched && signupForm.get('mobileNumber')?.hasError('pattern')">Enter a valid 10-digit mobile number.</small>
                  </div>
                </div>
              </div>

              <!-- Professional Details (Conditional) -->
              <div class="form-section animate-fade" *ngIf="selectedRole !== 'Student'">
                <div class="section-header">
                  <div class="section-num">02</div>
                  <h3 class="section-label">Professional Details</h3>
                </div>

                <div class="form-row">
                  <div class="input-group" *ngIf="selectedRole === 'Teacher'">
                    <label>Subject / Department <span class="req">*</span></label>
                    <div class="input-wrap">
                      <i class="fas fa-book input-icon"></i>
                      <input type="text" formControlName="specialization" placeholder="e.g. Mathematics" />
                    </div>
                  </div>
                  <div class="input-group" *ngIf="selectedRole === 'Teacher'">
                    <label>Employee ID <span class="req">*</span></label>
                    <div class="input-wrap">
                      <i class="fas fa-id-card input-icon"></i>
                      <input type="text" formControlName="licenseNumber" placeholder="TCH-001" />
                    </div>
                  </div>
                  <div class="input-group" *ngIf="selectedRole === 'Staff'">
                    <label>Staff ID</label>
                    <div class="input-wrap">
                      <i class="fas fa-id-badge input-icon"></i>
                      <input type="text" formControlName="employeeId" placeholder="STF-001" />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Account Security -->
              <div class="form-section">
                <div class="section-header">
                  <div class="section-num">
                    {{ selectedRole !== 'Student' ? '03' : '02' }}
                  </div>
                  <h3 class="section-label">Account Security</h3>
                </div>

                <div class="form-row">
                  <div class="input-group">
                    <label>Username <span class="req">*</span></label>
                    <div class="input-wrap">
                      <i class="fas fa-at input-icon"></i>
                      <input type="text" formControlName="username" placeholder="rahulsharma_sch" />
                    </div>
                    <small class="field-error" *ngIf="signupForm.get('username')?.touched && signupForm.get('username')?.hasError('required')">Username is required.</small>
                  </div>
                  <div class="input-group" *ngIf="otpSent">
                    <label>Verify OTP <span class="req">*</span></label>
                    <div class="input-wrap">
                      <i class="fas fa-shield-alt input-icon"></i>
                      <input type="text" formControlName="otp" placeholder="6-digit code" maxlength="6" class="otp-input" />
                    </div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="input-group">
                    <label>Password <span class="req">*</span></label>
                    <div class="input-wrap">
                      <i class="fas fa-lock input-icon"></i>
                      <input type="password" formControlName="password" placeholder="Min. 6 characters" />
                    </div>
                    <small class="field-error" *ngIf="signupForm.get('password')?.touched && signupForm.get('password')?.hasError('minlength')">Password must be at least 6 characters.</small>
                  </div>
                  <div class="input-group">
                    <label>Confirm Password <span class="req">*</span></label>
                    <div class="input-wrap">
                      <i class="fas fa-lock input-icon"></i>
                      <input type="password" formControlName="confirmPassword" placeholder="Re-enter password" />
                    </div>
                    <small class="field-error" *ngIf="signupForm.hasError('mismatch') && signupForm.get('confirmPassword')?.touched">Passwords do not match.</small>
                  </div>
                </div>
              </div>

              <button type="submit" class="btn-submit" [disabled]="signupForm.invalid">
                <span>Complete Registration</span>
                <i class="fas fa-arrow-right"></i>
              </button>

              <p class="terms-text">
                By registering, you agree to our
                <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>.
              </p>
            </form>
          </div>
        </div>
      </section>
    </main>

    <footer class="bottom-bar">
      <span>&copy; 2026 Nishwik School OS. Built for modern education.</span>
      <!-- <div class="social-links">
        <a href="#" aria-label="LinkedIn"><i class="fab fa-linkedin"></i></a>
        <a href="#" aria-label="Twitter"><i class="fab fa-twitter"></i></a>
      </div> -->
    </footer>
  </div>
</div>